import React from 'react';
import styled from 'styled-components';
import { TimestampLog } from './timestamp-log';

const LogContent = styled.div`
  flex: 1;
  font-size: 14px;
  line-height: 2;
  color: rgba(0, 0, 0, 0.85);
`;

/**
 * Renders component that provides a description of the event being displayed by the activity feed.
 *
 * @param {string} props.source tells who the event originated from (E.g.: When a user
 *  writes a note, the source of the "note added" event is its author, the user)
 * @param {string} props.event notification string of event that took place. E.g. "added a note"
 * @param {string} props.dateTime
 */
export function EventLog({ source, event, eventReactNode, dateTime }) {
  return (
    <div css="display: flex; justify-content: space-between;">
      <LogContent>
        <span css="font-weight: 900; text-transform: capitalize;">
          {source}&nbsp;
        </span>
        <span>{eventReactNode || event}</span>
      </LogContent>
      <TimestampLog dateTime={dateTime} />
    </div>
  );
}
